<div class="main-content d-flex flex-column">
  <div class="d-flex flex-row w-100 header justify-content-between">
    <div>
      <span class="title1">Filtros</span>
    </div>
    <div>
      <div (click)="closeMenu()" class="close-icon">
        <img src="../../../assets/Icons/close-line.png" alt="close">
      </div>
    </div>
  </div>
  <div class="search-topics">
    <div class="search-topic">
      <h4>Família</h4>
      <mat-form-field>
        <mat-select [(value)]="selectedFamily" (selectionChange)="onFamilyChange()"
          [compareWith]="compareFamilyObjects">
          <mat-option>---</mat-option>
          @for (family of sortFamilyItems; track family) {
            <mat-option [value]="family">
              {{family.descricao}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    @if (shouldShow2ndFilter) {
      <div class="search-topic">
        @if (!shouldChange) {
          <h4>Tipo</h4>
        }
        @if (shouldChange) {
          <h4>Substâncias Ativas</h4>
        }
        <mat-form-field>
          <input class="input-txt-address" type="text" matInput [formControl]="filter2ndControl"
            [matAutocomplete]="auto" />
            <mat-autocomplete (optionsScroll)="onScroll('type')" #auto="matAutocomplete"
              (optionSelected)="typeSelection($event)">
              @for (type of typeObservable | async | slice: 0 : 100; track type) {
                <mat-option [value]="type">
                  {{ type.descricao }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
      }
      @if (shouldShow3rdFilter) {
        <div class="search-topic">
          @if (!shouldChange) {
            <h4>Marca</h4>
          }
          @if (shouldChange) {
            <h4>ATC</h4>
          }
          <mat-form-field>
            <input class="input-txt-address" type="text" matInput [formControl]="filter3rdControl"
              [matAutocomplete]="auto" />
              <mat-autocomplete (optionsScroll)="onScroll('brand')" #auto="matAutocomplete"
                (optionSelected)="brandSelection($event)">
                @for (brand of brandObservable | async | slice: 0 : 100; track brand) {
                  <mat-option [value]="brand">
                    {{brand.descricao}}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
        }
        @if (shouldShow4thFilter) {
          <div class="search-topic">
            <h4>Idade</h4>
            <mat-form-field>
              <input class="input-txt-address" type="text" matInput [formControl]="filter4thControl"
                [matAutocomplete]="autoIdade" />
                <mat-autocomplete (optionsScroll)="onScroll('structure')" #autoIdade="matAutocomplete"
                  (optionSelected)="structureSelection($event)">
                  @for (structure of structureObservable | async | slice: 0 : 100; track structure) {
                    <mat-option [value]="structure">
                      {{structure.descricao}}
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </div>
          }
          <div class="search-topic">
            <h4>Especie</h4>
            <mat-form-field>
              <mat-select [(value)]="selectedSpecie" [compareWith]="compareSpeciesObjects">
                <mat-option>---</mat-option>
                @for (specie of sortSpecieItems; track specie) {
                  <mat-option [value]="specie">
                    {{specie.nomeDisplay}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="btn-apply" (click)="applyFilters()"><span>Aplicar</span></div>
      </div>
